export const environment = {
  production: true,
  hmr: false,
  envName: "production",
  apiUrl: "https://api.clienthub.app",
  frontUrl: "https://use.clienthub.app/#/",
  socketUrl: "https://socket.clienthub.app",
  stripeKey: "pk_live_9ja6MPtpem1IyQVTrMayaXoU",
  firebaseConfig: {
    apiKey: "AIzaSyAWeO8T26AI8EyYa_GKZEO9Xovba5shpMg",
    authDomain: "cloud-client-hub.firebaseapp.com",
    databaseURL: "https://cloud-client-hub.firebaseio.com",
    projectId: "cloud-client-hub",
    storageBucket: "cloud-client-hub.appspot.com",
    messagingSenderId: "935076658406",
    dbName: null,
  },
  pusherConfig: {
    pusherAppKey: "dae98e86bed78d4e49ad",
    pusherAppCluster: "mt1",
    pusherAppSecure: true,
  },
  agoraConfig: {
    appId: "",
    customerId: "",
    customerSecret: "",
  },
  csvBoxConfig: {
    licenseKey: "RtY109wNN8VWLLkVeyTmQcxrLR2vYE",
  },
  captchaSiteKey: "0x4AAAAAAAcu84tEqbmk9qoV",
  posthog: {
    key: "phc_pJdpmM6cbMu8wFUngSeKV8BT0zBVaK8cmX7XoujEKAM",
    host: "https://us.i.posthog.com",
  },
  aiBackendUrl: "https://async.clienthub.app",
};
